export default __webpack_public_path__ + "static/SMP-8d3462ebf7c8504114dfbbaad945141b.webp";